// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// // import { gapi } from "gapi-script";
// // import { clienId } from "../Login/globalMethods";
// import { Container, Accordion, ListGroup, Row, Col } from "react-bootstrap";
// import "../../assets/css/profile.css";
// import { IoIosArrowForward } from "react-icons/io";
// import { GrFormAdd } from "react-icons/gr";
// import { TbCurrencyRupee } from "react-icons/tb";
// import UserLogout from "../Login/userLogout";
// import { AddressForm } from "../Forms/addressForm";
// import { userInfo } from "../../utils/appInfo";
// import NotificationMsg from "../Notification";
// import { SERVER_PATH } from "../../config/env";
// import { ToastContainer } from "react-toastify";
// import apiClient from "../../utils/api";

// export default function Profile() {
//   const [data, setData] = useState([]);
//   const [state, setState] = useState("profile");
//   const [formData, setFormData] = useState(false);
//   const [userData, setUserData] = useState(false);

//   const showForm = (clickData) => {
//     setFormData(clickData);
//   };

//   const eventHandler = (clickState) => {
//     setState(clickState);
//   };

//   const fetchData = async () => {
//     await apiClient
//       .post(`get/order.php`, {
//         user_id: userData.email,
//       })
//       .then((res) => {
//         setData(res.data);
//       })
//       .catch((err) => {
//         console.log(err);
//       });
//   };

//   const [addressData, setAddressData] = useState([]);

//   const addressFetchData = async () => {
//     await apiClient
//       .post(`get/user.php`, {
//         user_id: userData.email,
//       })
//       .then((res) => {
//         setAddressData(res.data);
//       })
//       .catch((err) => {
//         console.log(err);
//       });
//   };

//   useEffect(() => {
//     setTimeout(() => {
//       setUserData(userInfo());
//       window.scrollTo(0, 0);
//       // fetchData();
//     }, 1000);

//     // function start() {
//     //   gapi.client.init({
//     //     clientId: clienId,
//     //     scope: "email",
//     //   });
//     // }
//     // gapi.load("client:auth2", start);
//   }, []);

//   return (
//     <>
//       <Container fluid className="productPage">
//         <div className="main-body">
//           <div className="row gutters-sm">
//             <div className="col-md-4 mb-3 ">
//               <div className="card shadow-sm">
//                 <div className="card-body">
//                   <div className="d-flex flex-column align-items-center text-center">
//                     <img
//                       src={
//                         userData.picture
//                           ? userData.picture
//                           : "https://bootdey.com/img/Content/avatar/avatar7.png"
//                       }
//                       alt="profile"
//                       className="rounded-circle"
//                       width="150"
//                     />
//                     <div className="mt-3">
//                       <h4>{userData.name}</h4>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//               <div className="card mt-3">
//                 <Accordion defaultActiveKey="0">
//                   <Accordion.Item eventKey="0">
//                     <Accordion.Header>Account Information</Accordion.Header>
//                     <Accordion.Body>
//                       <ListGroup>
//                         <ListGroup.Item onClick={() => eventHandler("profile")}>
//                           <IoIosArrowForward />
//                           Profile Information
//                         </ListGroup.Item>
//                         <ListGroup.Item
//                           onClick={() => {
//                             eventHandler("address");
//                             addressFetchData();
//                           }}>
//                           <IoIosArrowForward />
//                           Address Information
//                         </ListGroup.Item>
//                         <ListGroup.Item
//                           onClick={() => {
//                             eventHandler("myOrders");
//                             fetchData();
//                           }}>
//                           <IoIosArrowForward />
//                           My Orders
//                         </ListGroup.Item>
//                         <ListGroup.Item
//                           onClick={() => eventHandler("notifocation")}>
//                           <IoIosArrowForward />
//                           Notifications
//                         </ListGroup.Item>
//                       </ListGroup>
//                     </Accordion.Body>
//                   </Accordion.Item>
//                 </Accordion>
//               </div>
//             </div>
//             <div className="col-md-8">
//               <div className="card mb-3">
//                 {state === "profile" ? (
//                   <div className="card-body detailsDiv">
//                     <Row>
//                       <div className="mb-4 d-flex align-items-center">
//                         <span className="h4">Profile Details</span>
//                         {/* <span className="btn" style={{ color: "blue" }}>
//                           Edit
//                         </span> */}
//                       </div>
//                     </Row>
//                     <Row>
//                       <div className="col-sm-3">
//                         <h6 className="mb-0">Username</h6>
//                       </div>
//                       <div className="col-sm-9 text-secondary">
//                         <input
//                           type="text"
//                           placeholder={userData.name}
//                           disabled
//                           tyle={{ width: "100%" }}
//                         />
//                       </div>
//                     </Row>
//                     <hr />
//                     <Row>
//                       <div className="col-sm-3">
//                         <h6 className="mb-0">Email</h6>
//                       </div>
//                       <div className="col-sm-9 text-secondary">
//                         <input
//                           type="email"
//                           placeholder={userData.email}
//                           disabled
//                           style={{ width: "100%" }}
//                         />
//                       </div>
//                     </Row>
//                     <hr />
//                     <Row>
//                       <div className="col-sm-12">
//                         <UserLogout />
//                       </div>
//                     </Row>
//                   </div>
//                 ) : state === "address" ? (
//                   <div className="card-body addressDiv">
//                     <Row>
//                       <div>
//                         <h4 className="mb-3">Manage Addresses</h4>
//                         <div>
//                           <button
//                             className="d-flex align-items-center"
//                             onClick={() => showForm(true)}>
//                             <GrFormAdd />
//                             Add new address
//                           </button>
//                           {formData && (
//                             <AddressForm
//                               hide={() => showForm(false)}
//                               addressData={addressFetchData}
//                             />
//                           )}
//                           <hr style={{ color: "#000" }} />
//                           <h4 className="mb-3">My Address</h4>
//                           <div>
//                             {addressData.map((d, i) => {
//                               return d.state == "0" ? (
//                                 <h4>Enter your address</h4>
//                               ) : (
//                                 <address>
//                                   <p className="mb-0">{d.user_name},</p>
//                                   <p className="mb-0">{d.mobile_no},</p>
//                                   <p className="mb-0">{d.address}</p>
//                                   <p className="mb-0">{d.state}</p>
//                                   <p>{d.pincode}</p>
//                                 </address>
//                               );
//                             })}
//                           </div>
//                         </div>
//                       </div>
//                     </Row>
//                   </div>
//                 ) : state === "myOrders" ? (
//                   <div className="card-body addressDiv">
//                     <Row>
//                       <div>
//                         <h4 className="mb-3">My Orders</h4>
//                         <hr color="#e0e0e0" />
//                         <Col
//                           className="mb-3 shadow-none"
//                           style={{ maxHeight: "400px", overflowY: "scroll" }}>
//                           {data.map((d) => {
//                             return (
//                               <>
//                                 <div
//                                   className="card-body mb-2 d-none d-sm-block"
//                                   style={{
//                                     borderColor: "#e0e0e0",
//                                     borderStyle: "solid",
//                                     borderWidth: "1px",
//                                   }}>
//                                   <div className="d-flex justify-content-between">
//                                     <div className="d-flex flex-row align-items-center">
//                                       <div
//                                         style={{ width: "65px" }}
//                                         className="d-none d-sm-block">
//                                         <Link
//                                           to={`/product/${d.product_id}`}
//                                           className="text-decoration-none">
//                                           <img
//                                             src={d.img1}
//                                             className="img-fluid"
//                                             alt=""
//                                             style={{
//                                               width: "65px",
//                                               height: "50px",
//                                               objectFit: "cover",
//                                             }}
//                                           />
//                                         </Link>
//                                       </div>
//                                       <div
//                                         className="ms-3"
//                                         style={{ width: "180px" }}>
//                                         <Link
//                                           to={`/product/${d.product_id}`}
//                                           className="text-decoration-none text-dark">
//                                           <h6 className="text-uppercase">
//                                             {d?.product_name}
//                                             <small
//                                               className="text-secondary ms-1"
//                                               style={{ fontSize: "12px" }}>
//                                               {d?.weight}Gms
//                                             </small>
//                                           </h6>
//                                           <p className="small mb-0 text-uppercase text-secondary">
//                                             {d?.category}
//                                           </p>
//                                         </Link>
//                                       </div>
//                                     </div>
//                                     <div className="d-flex flex-row align-items-center">
//                                       <div style={{ width: "100px" }}>
//                                         <h6>Status</h6>
//                                         <p className="small mb-0">
//                                           {d?.status}
//                                         </p>
//                                       </div>
//                                     </div>
//                                     <div className="d-flex flex-row align-items-center">
//                                       <div style={{ width: "80px" }}>
//                                         <h5>{d?.quantity}</h5>
//                                         <p className="small mb-0">Qty</p>
//                                       </div>
//                                       <div style={{ width: "100px" }}>
//                                         <h5 className="mb-0">
//                                           <TbCurrencyRupee
//                                             style={{ marginTop: "-3px" }}
//                                           />
//                                           {d.offer_price * d.quantity}
//                                         </h5>
//                                         <p className="small mb-0 text-center">
//                                           Price
//                                         </p>
//                                       </div>
//                                     </div>
//                                   </div>
//                                 </div>
//                                 {/* mobile cart div */}
//                                 <div
//                                   className="card-body mb-2 d-block d-sm-none"
//                                   style={{
//                                     borderColor: "#e0e0e0",
//                                     borderStyle: "solid",
//                                     borderWidth: "1px",
//                                   }}>
//                                   <div className="d-flex flex-row align-items-center">
//                                     <div style={{ width: "75px" }}>
//                                       <Link
//                                         to={`/product/${d.product_id}`}
//                                         className="text-decoration-none">
//                                         <img
//                                           src={d.img1}
//                                           className="img-fluid mb-3"
//                                           alt=""
//                                           style={{
//                                             width: "65px",
//                                             height: "50px",
//                                             objectFit: "cover",
//                                           }}
//                                         />
//                                       </Link>
//                                     </div>
//                                     <div style={{ width: "200px" }}>
//                                       <Link
//                                         to={`/product/${d.product_id}`}
//                                         className="text-decoration-none text-dark">
//                                         <h5 className="text-uppercase">
//                                           {d?.product_name}
//                                           <small
//                                             className="text-secondary ms-1"
//                                             style={{ fontSize: "12px" }}>
//                                             {d?.weight}Gms
//                                           </small>
//                                         </h5>
//                                         <p className="small mb-3 text-uppercase text-secondary">
//                                           {d?.category}
//                                         </p>
//                                       </Link>
//                                     </div>
//                                   </div>
//                                   <div className="d-flex justify-content-between">
//                                     <div className="d-flex flex-row align-items-center">
//                                       <div style={{ width: "100px" }}>
//                                         <h6>Status</h6>
//                                         <p className="small mb-0">
//                                           {d?.status}
//                                         </p>
//                                       </div>
//                                     </div>
//                                     <div className="d-flex flex-row align-items-center">
//                                       <div style={{ width: "100px" }}>
//                                         <h5>{d?.quantity}</h5>
//                                         <p className="small mb-0">Qty</p>
//                                       </div>
//                                       <div style={{ width: "80px" }}>
//                                         <h5 className="mb-0">
//                                           <TbCurrencyRupee
//                                             style={{ marginTop: "-3px" }}
//                                           />
//                                           {d.offer_price * d.quantity}
//                                         </h5>
//                                         <p className="small mb-0 text-center">
//                                           Price
//                                         </p>
//                                       </div>
//                                     </div>
//                                   </div>
//                                 </div>
//                               </>
//                             )
//                           })}
//                         </Col>
//                       </div>
//                     </Row>
//                   </div>
//                 ) : (
//                   <div className="card-body addressDiv">
//                     <Row>
//                       <div>
//                         <h4 className="mb-3">Notifications</h4>
//                         <hr color="#e0e0e0" />
//                         <NotificationMsg />
//                       </div>
//                     </Row>
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       </Container>
//       <ToastContainer />
//     </>
//   );
// }

// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// import { Container, Accordion, ListGroup, Row, Col } from "react-bootstrap";
// import "../../assets/css/profile.css";
// import { IoIosArrowForward } from "react-icons/io";
// import { GrFormAdd } from "react-icons/gr";
// import UserLogout from "../Login/userLogout";
// import { AddressForm } from "../Forms/addressForm";
// import { userInfo } from "../../utils/appInfo";
// import NotificationMsg from "../Notification";
// import { ToastContainer } from "react-toastify";
// import apiClient from "../../utils/api";
// import { OverlayTrigger, Tooltip } from "react-bootstrap";

// export default function Profile() {
//   const [data, setData] = useState([]);
//   const [state, setState] = useState("profile");
//   const [userData, setUserData] = useState({});
//   const [addressData, setAddressData] = useState([]);
//   const [returningProductId, setReturningProductId] = useState(null);

//   // ✅ Added missing states
//   const [formData, setFormData] = useState(false);
//   const showForm = (val) => setFormData(val);

//   const fetchData = async () => {
//     try {
//       const res = await apiClient.post(`get/order.php`, {
//         user_id: userData.email,
//       });
//       setData(res.data);
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   const addressFetchData = async () => {
//     try {
//       const res = await apiClient.post(`get/user.php`, {
//         user_id: userData.email,
//       });
//       setAddressData(res.data);
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   const handleReturn = async (productId) => {
//     const confirmReturn = window.confirm(
//       "Are you sure you want to return this product?"
//     );
//     if (!confirmReturn) return;

//     try {
//       setReturningProductId(productId);
//       const res = await apiClient.post(`put/returnRequest.php`, {
//         user_id: userData.email,
//         product_id: productId,
//       });

//       if (res.data.success) {
//         alert("Return request submitted successfully!");
//         fetchData();
//       } else {
//         alert(res.data.message || "Return request failed!");
//       }
//     } catch (err) {
//       console.log(err);
//       alert("Error processing return.");
//     } finally {
//       setReturningProductId(null);
//     }
//   };

//   useEffect(() => {
//     setTimeout(() => {
//       const info = userInfo();
//       setUserData(info);
//       window.scrollTo(0, 0);
//     }, 1000);
//   }, []);

//   useEffect(() => {
//     if (userData?.email) {
//       fetchData();
//     }
//   }, [userData]);

//   return (
//     <>
//       <Container fluid className="productPage">
//         <div className="main-body">
//           <div className="row gutters-sm">
//             {/* Sidebar */}
//             <div className="col-md-4 mb-3">
//               <div className="card shadow-sm">
//                 <div className="card-body">
//                   <div className="d-flex flex-column align-items-center text-center">
//                     <img
//                       src={
//                         userData.picture
//                           ? userData.picture
//                           : "https://bootdey.com/img/Content/avatar/avatar7.png"
//                       }
//                       alt="profile"
//                       className="rounded-circle"
//                       width="150"
//                     />
//                     <div className="mt-3">
//                       <h4>{userData.name}</h4>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               <div className="card mt-3">
//                 <Accordion defaultActiveKey="0">
//                   <Accordion.Item eventKey="0">
//                     <Accordion.Header>Account Information</Accordion.Header>
//                     <Accordion.Body>
//                       <ListGroup>
//                         <ListGroup.Item onClick={() => setState("profile")}>
//                           <IoIosArrowForward />
//                           Profile Information
//                         </ListGroup.Item>
//                         <ListGroup.Item
//                           onClick={() => {
//                             setState("address");
//                             addressFetchData();
//                           }}
//                         >
//                           <IoIosArrowForward />
//                           Address Information
//                         </ListGroup.Item>
//                         <ListGroup.Item
//                           onClick={() => {
//                             setState("myOrders");
//                             fetchData();
//                           }}
//                         >
//                           <IoIosArrowForward />
//                           My Orders
//                         </ListGroup.Item>
//                         <ListGroup.Item
//                           onClick={() => {
//                             setState("return");
//                             fetchData();
//                           }}
//                         >
//                           <IoIosArrowForward />
//                           Returned Products
//                         </ListGroup.Item>
//                         <ListGroup.Item
//                           onClick={() => setState("notifocation")}
//                         >
//                           <IoIosArrowForward />
//                           Notifications
//                         </ListGroup.Item>
//                       </ListGroup>
//                     </Accordion.Body>
//                   </Accordion.Item>
//                 </Accordion>
//               </div>
//             </div>

//             {/* Main Content */}
//             <div className="col-md-8">
//               <div className="card mb-3">
//                 {state === "profile" && (
//                   <div className="card-body detailsDiv">
//                     <Row>
//                       <div className="mb-4 d-flex align-items-center">
//                         <span className="h4">Profile Details</span>
//                       </div>
//                     </Row>
//                     <Row>
//                       <div className="col-sm-3">
//                         <h6 className="mb-0">Username</h6>
//                       </div>
//                       <div className="col-sm-9 text-secondary">
//                         <input
//                           type="text"
//                           placeholder={userData.name}
//                           disabled
//                           style={{ width: "100%" }}
//                         />
//                       </div>
//                     </Row>
//                     <hr />
//                     <Row>
//                       <div className="col-sm-3">
//                         <h6 className="mb-0">Email</h6>
//                       </div>
//                       <div className="col-sm-9 text-secondary">
//                         <input
//                           type="email"
//                           placeholder={userData.email}
//                           disabled
//                           style={{ width: "100%" }}
//                         />
//                       </div>
//                     </Row>
//                     <hr />
//                     <Row>
//                       <div className="col-sm-12">
//                         <UserLogout />
//                       </div>
//                     </Row>
//                   </div>
//                 )}

//                 {state === "address" && (
//                   <div className="card-body addressDiv">
//                     <Row>
//                       <div>
//                         <h4 className="mb-3">Manage Addresses</h4>
//                         <div>
//                           <button
//                             className="d-flex align-items-center"
//                             onClick={() => showForm(true)}
//                           >
//                             <GrFormAdd />
//                             Add new address
//                           </button>
//                           {formData && (
//                             <AddressForm
//                               hide={() => showForm(false)}
//                               addressData={addressFetchData}
//                             />
//                           )}
//                           <hr style={{ color: "#000" }} />
//                           <h4 className="mb-3">My Address</h4>
//                           <div>
//                             {addressData.map((d, i) => {
//                               return d.state == "0" ? (
//                                 <h4 key={i}>Enter your address</h4>
//                               ) : (
//                                 <address key={i}>
//                                   <p className="mb-0">{d.user_name},</p>
//                                   <p className="mb-0">{d.mobile_no},</p>
//                                   <p className="mb-0">{d.address}</p>
//                                   <p className="mb-0">{d.state}</p>
//                                   <p>{d.pincode}</p>
//                                 </address>
//                               );
//                             })}
//                           </div>
//                         </div>
//                       </div>
//                     </Row>
//                   </div>
//                 )}

//                 {state === "myOrders" && (
//                   <div className="card-body addressDiv">
//                     <Row>
//                       <div>
//                         <h4 className="mb-3">My Orders</h4>
//                         <hr color="#e0e0e0" />
//                         <Col
//                           className="mb-3 shadow-none"
//                           style={{ maxHeight: "400px", overflowY: "scroll" }}
//                         >
//                           {data.filter((d) => d.returned === "0").length > 0 ? (
//                             data
//                               .filter((d) => d.returned === "0")
//                               .map((d, i) => (
//                                 <div
//                                   key={i}
//                                   className="card-body mb-2"
//                                   style={{ border: "1px solid #e0e0e0" }}
//                                 >
//                                   <div className="d-flex justify-content-between">
//                                     <div className="d-flex flex-row align-items-center">
//                                       <div style={{ width: "65px" }}>
//                                         <Link
//                                           to={`/product/${d.product_id}`}
//                                           className="text-decoration-none"
//                                         >
//                                           <img
//                                             src={d.img1}
//                                             className="img-fluid"
//                                             alt=""
//                                             style={{
//                                               width: "65px",
//                                               height: "50px",
//                                               objectFit: "cover",
//                                             }}
//                                           />
//                                         </Link>
//                                       </div>
//                                       <div
//                                         className="ms-3"
//                                         style={{ width: "180px" }}
//                                       >
//                                         <Link
//                                           to={`/product/${d.product_id}`}
//                                           className="text-decoration-none text-dark"
//                                         >
//                                           <h6 className="text-uppercase">
//                                             {d.product_name}
//                                           </h6>
//                                           <p className="small mb-0 text-uppercase text-secondary">
//                                             {d.category}
//                                           </p>
//                                         </Link>
//                                       </div>
//                                     </div>
//                                     <div className="d-flex flex-column align-items-end">
//                                       <h6>Status: {d.status}</h6>
//                                       <h6>
//                                         Qty: {d.quantity} | ₹
//                                         {d.offer_price * d.quantity}
//                                       </h6>

//                                       {d.status === "confirm" ? (
//                                         <button
//                                           className="btn btn-sm btn-outline-danger mt-2"
//                                           onClick={() =>
//                                             handleReturn(d.product_id)
//                                           }
//                                           disabled={
//                                             returningProductId === d.product_id
//                                           }
//                                         >
//                                           {returningProductId === d.product_id
//                                             ? "Processing..."
//                                             : "Return"}
//                                         </button>
//                                       ) : (
//                                         <OverlayTrigger
//                                           placement="top"
//                                           overlay={
//                                             <Tooltip
//                                               id={`tooltip-${d.product_id}`}
//                                             >
//                                               If the product is damaged or has
//                                               any issues after delivery, you can
//                                               click the "Return" button.
//                                             </Tooltip>
//                                           }
//                                         >
//                                           <span
//                                             // className="text-muted"
//                                             style={{
//                                               fontSize: "16px",
//                                               cursor: "pointer",
//                                               fontWeight: "bold",
//                                               color: "rgba(4, 84, 2, 1)",
//                                             }}
//                                           >
//                                             Touch me
//                                           </span>
//                                         </OverlayTrigger>
//                                       )}
//                                     </div>
//                                   </div>
//                                 </div>
//                               ))
//                           ) : (
//                             <p className="text-center">No orders found.</p>
//                           )}
//                         </Col>
//                       </div>
//                     </Row>
//                   </div>
//                 )}

//                 {state === "return" && (
//                   <div className="card-body addressDiv">
//                     <Row>
//                       <div>
//                         <h4 className="mb-3">Returned Products</h4>
//                         <hr color="#e0e0e0" />
//                         <Col
//                           className="mb-3 shadow-none"
//                           style={{ maxHeight: "400px", overflowY: "scroll" }}
//                         >
//                           {data.filter((d) => d.returned === "1").length > 0 ? (
//                             data
//                               .filter((d) => d.returned === "1")
//                               .map((d, i) => (
//                                 <div
//                                   key={i}
//                                   className="card-body mb-2"
//                                   style={{ border: "1px solid #e0e0e0" }}
//                                 >
//                                   <div className="d-flex justify-content-between align-items-center">
//                                     <div className="d-flex align-items-center">
//                                       <img
//                                         src={d.img1}
//                                         alt="Returned"
//                                         style={{
//                                           width: "65px",
//                                           height: "50px",
//                                           objectFit: "cover",
//                                           marginRight: "15px",
//                                         }}
//                                       />
//                                       <div>
//                                         <h6 className="text-uppercase">
//                                           {d.product_name}
//                                         </h6>
//                                         <p className="mb-0 text-muted">
//                                           {d.category}
//                                         </p>
//                                       </div>
//                                     </div>
//                                     <span
//                                       className={`badge ${
//                                         d.return_status === "Accepted"
//                                           ? "bg-success"
//                                           : "bg-warning"
//                                       }`}
//                                     >
//                                       {d.return_status === "Accepted"
//                                         ? "Accepted"
//                                         : "Return Requested"}
//                                     </span>
//                                   </div>
//                                 </div>
//                               ))
//                           ) : (
//                             <p className="text-center">
//                               No return records found.
//                             </p>
//                           )}
//                         </Col>
//                       </div>
//                     </Row>
//                   </div>
//                 )}

//                 {state === "notifocation" && (
//                   <div className="card-body addressDiv">
//                     <Row>
//                       <div>
//                         <h4 className="mb-3">Notifications</h4>
//                         <hr color="#e0e0e0" />
//                         <NotificationMsg />
//                       </div>
//                     </Row>
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       </Container>
//       <ToastContainer />
//     </>
//   );
// }

import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Container, Accordion, ListGroup, Row, Col } from "react-bootstrap";
import "../../assets/css/profile.css";
import { IoIosArrowForward } from "react-icons/io";
import { GrFormAdd } from "react-icons/gr";
import UserLogout from "../Login/userLogout";
import { AddressForm } from "../Forms/addressForm";
import { userInfo } from "../../utils/appInfo";
import NotificationMsg from "../Notification";
import { ToastContainer } from "react-toastify";
import apiClient from "../../utils/api";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import "./style.css";

export default function Profile() {
  const [orders, setOrders] = useState([]); // renamed from 'data'
  const [returnData, setReturnData] = useState([]); // NEW: returned products
  const [state, setState] = useState("profile");
  const [userData, setUserData] = useState({});
  const [addressData, setAddressData] = useState([]);
  const [returningProductId, setReturningProductId] = useState(null);

  // ✅ Added missing states
  const [formData, setFormData] = useState(false);
  const showForm = (val) => setFormData(val);

  // --- ORDERS FETCH ---------------------------------------------------------
  const fetchOrders = async () => {
    if (!userData?.email) return;
    try {
      const res = await apiClient.post(`get/order.php`, {
        user_id: userData.email,
      });
      setOrders(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.log("fetchOrders err:", err);
      setOrders([]);
    }
  };

  // --- RETURN ORDERS FETCH ---------------------------------------------------
  // Expected response: array of objects incl. product_id, product_name, img1, category, return_status
  const fetchReturnOrders = async () => {
    if (!userData?.email) return;
    try {
      const res = await apiClient.post(`get/userreturnOrders.php`, {
        user_id: userData.email,
      });
      setReturnData(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.log("fetchReturnOrders err:", err);
      setReturnData([]);
    }
  };

  // --- ADDRESS FETCH ---------------------------------------------------------
  const addressFetchData = async () => {
    if (!userData?.email) return;
    try {
      const res = await apiClient.post(`get/user.php`, {
        user_id: userData.email,
      });
      setAddressData(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.log("addressFetchData err:", err);
      setAddressData([]);
    }
  };

  // --- RETURN REQUEST SUBMIT -------------------------------------------------
  const handleReturn = async (productId) => {
    const confirmReturn = window.confirm(
      "Are you sure you want to return this product?"
    );
    if (!confirmReturn) return;

    try {
      setReturningProductId(productId);
      const res = await apiClient.post(`put/returnRequest.php`, {
        user_id: userData.email,
        product_id: productId,
      });

      if (res.data?.success) {
        alert("Return request submitted successfully!");
        // Refresh both orders (to flip returned flag) and returnData (to show request)
        fetchOrders();
        fetchReturnOrders();
      } else {
        alert(res.data?.message || "Return request failed!");
      }
    } catch (err) {
      console.log(err);
      alert("Error processing return.");
    } finally {
      setReturningProductId(null);
    }
  };

  // --- INITIAL USER LOAD ----------------------------------------------------
  useEffect(() => {
    const timer = setTimeout(() => {
      const info = userInfo();
      setUserData(info);
      window.scrollTo(0, 0);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  // --- LOAD ORDERS / RETURNS ON USER READY -----------------------------------
  useEffect(() => {
    if (userData?.email) {
      fetchOrders();
      fetchReturnOrders(); // prefetch so it's ready when user clicks tab
    }
  }, [userData]);

  // --- BADGE HELPERS ---------------------------------------------------------
  const getReturnBadge = (status) => {
    // Normalize for safety
    const s = (status || "").toLowerCase();
    if (s === "accepted" || s === "approved") {
      return { className: "bg-success", label: "Accepted" };
    } else if (s === "rejected" || s === "declined") {
      return { className: "bg-danger", label: "Rejected" };
    } else if (
      s === "requested" ||
      s === "pending" ||
      s === "return requested"
    ) {
      return { className: "bg-warning text-dark", label: "Return Requested" };
    }
    return { className: "bg-secondary", label: status || "Unknown" };
  };

useEffect(() => {
  const style = document.createElement("style");
  style.innerHTML = `
    @media (max-width: 998px) {
      .custom-mobile-margin {
        margin-top: 10% !important;
      }
    }
      @media (max-width: 750px) {
      .custom-mobile-margin {
        margin-top: 15% !important;
      }
    }
      @media (max-width: 500px) {
      .custom-mobile-margin {
        margin-top: 19% !important;
      }
    }
  `;
  document.head.appendChild(style);

  return () => {
    document.head.removeChild(style);
  };
}, []);

  return (
    <>
      <Container fluid className="productPage">
        <div className="main-body">
          <div className="row gutters-sm custom-mobile-margin">
            {/* Sidebar */}
            <div className="col-md-4 mb-3">
              <div className="card shadow-sm">
                <div className="card-body">
                  <div className="d-flex flex-column align-items-center text-center">
                    <img
                      src={
                        userData.picture
                          ? userData.picture
                          : "https://bootdey.com/img/Content/avatar/avatar7.png"
                      }
                      alt="profile"
                      className="rounded-circle"
                      width="150"
                    />
                    <div className="mt-3">
                      <h4>{userData.name}</h4>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card mt-3">
                <Accordion defaultActiveKey="0">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>Account Information</Accordion.Header>
                    <Accordion.Body>
                      <ListGroup>
                        <ListGroup.Item onClick={() => setState("profile")}>
                          <IoIosArrowForward />
                          Profile Information
                        </ListGroup.Item>
                        <ListGroup.Item
                          onClick={() => {
                            setState("address");
                            addressFetchData();
                          }}
                        >
                          <IoIosArrowForward />
                          Address Information
                        </ListGroup.Item>
                        <ListGroup.Item
                          onClick={() => {
                            setState("myOrders");
                            fetchOrders();
                          }}
                        >
                          <IoIosArrowForward />
                          My Orders
                        </ListGroup.Item>
                        <ListGroup.Item
                          onClick={() => {
                            setState("return");
                            fetchReturnOrders(); // <-- now loads return orders
                          }}
                        >
                          <IoIosArrowForward />
                          Returned Products
                        </ListGroup.Item>
                        <ListGroup.Item
                          onClick={() => setState("notifocation")}
                        >
                          <IoIosArrowForward />
                          Notifications
                        </ListGroup.Item>
                      </ListGroup>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </div>
            </div>

            {/* Main Content */}
            <div className="col-md-8">
              <div className="card mb-3">
                {state === "profile" && (
                  <div className="card-body detailsDiv">
                    <Row>
                      <div className="mb-4 d-flex align-items-center">
                        <span className="h4">Profile Details</span>
                      </div>
                    </Row>
                    <Row>
                      <div className="col-sm-3">
                        <h6 className="mb-0">Username</h6>
                      </div>
                      <div className="col-sm-9 text-secondary">
                        <input
                          type="text"
                          placeholder={userData.name}
                          disabled
                          style={{ width: "100%" }}
                        />
                      </div>
                    </Row>
                    <hr />
                    <Row>
                      <div className="col-sm-3">
                        <h6 className="mb-0">Email</h6>
                      </div>
                      <div className="col-sm-9 text-secondary">
                        <input
                          type="email"
                          placeholder={userData.email}
                          disabled
                          style={{ width: "100%" }}
                        />
                      </div>
                    </Row>
                    <hr />
                    <Row>
                      <div className="col-sm-12">
                        <UserLogout />
                      </div>
                    </Row>
                  </div>
                )}

                {state === "address" && (
                  <div className="card-body addressDiv">
                    <Row>
                      <div>
                        <h4 className="mb-3">Manage Addresses</h4>
                        <div>
                          <button
                            className="d-flex align-items-center"
                            onClick={() => showForm(true)}
                          >
                            <GrFormAdd />
                            Add new address
                          </button>
                          {formData && (
                            <AddressForm
                              hide={() => showForm(false)}
                              addressData={addressFetchData}
                            />
                          )}
                          <hr style={{ color: "#000" }} />
                          <h4 className="mb-3">My Address</h4>
                          <div>
                            {addressData.map((d, i) => {
                              return d.state === "0" ? (
                                <h4 key={i}>Enter your address</h4>
                              ) : (
                                <address key={i}>
                                  <p className="mb-0">{d.user_name},</p>
                                  <p className="mb-0">{d.mobile_no},</p>
                                  <p className="mb-0">{d.address}</p>
                                  <p className="mb-0">{d.state}</p>
                                  <p>{d.pincode}</p>
                                </address>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    </Row>
                  </div>
                )}

                {/* {state === "myOrders" && (
                  <div className="card-body addressDiv">
                    <Row>
                      <div>
                        <h4 className="mb-3">My Orders</h4>
                        <hr color="#e0e0e0" />
                        <Col
                          className="mb-3 shadow-none"
                          style={{ maxHeight: "400px", overflowY: "scroll" }}
                        >
                          {orders.filter((d) => d.returned === "0").length >
                          0 ? (
                            orders
                              .filter((d) => d.returned === "0")
                              .map((d, i) => (
                                <div
                                  key={i}
                                  className="card-body mb-2"
                                  style={{ border: "1px solid #e0e0e0" }}
                                >
                                  <div className="d-flex justify-content-between">
                                    <div className="d-flex flex-row align-items-center">
                                      <div style={{ width: "65px" }}>
                                        <Link
                                          to={`/product/${d.product_id}`}
                                          className="text-decoration-none"
                                        >
                                          <img
                                            src={d.img1}
                                            className="img-fluid"
                                            alt=""
                                            style={{
                                              width: "65px",
                                              height: "50px",
                                              objectFit: "cover",
                                            }}
                                          />
                                        </Link>
                                      </div>
                                      <div
                                        className="ms-3"
                                        style={{ width: "180px" }}
                                      >
                                        <Link
                                          to={`/product/${d.product_id}`}
                                          className="text-decoration-none text-dark"
                                        >
                                          <h6 className="text-uppercase">
                                            {d.product_name}
                                          </h6>
                                          <p className="small mb-0 text-uppercase text-secondary">
                                            {d.category}
                                          </p>
                                        </Link>
                                      </div>
                                    </div>
                                    <div className="d-flex flex-column align-items-end">
                                      <h6>Status: {d.status}</h6>
                                      <h6>
                                        Qty: {d.quantity} | ₹
                                        {d.offer_price * d.quantity}
                                      </h6>

                                      {d.status === "confirm" ? (
                                        <button
                                          className="btn btn-sm btn-outline-danger mt-2"
                                          onClick={() =>
                                            handleReturn(d.product_id)
                                          }
                                          disabled={
                                            returningProductId === d.product_id
                                          }
                                        >
                                          {returningProductId === d.product_id
                                            ? "Processing..."
                                            : "Return"}
                                        </button>
                                      ) : (
                                        <OverlayTrigger
                                          placement="top"
                                          overlay={
                                            <Tooltip
                                              id={`tooltip-${d.product_id}`}
                                            >
                                              If the product is damaged or has
                                              any issues after delivery, you can
                                              click the "Return" button.
                                            </Tooltip>
                                          }
                                        >
                                          <span
                                            style={{
                                              fontSize: "16px",
                                              cursor: "pointer",
                                              fontWeight: "bold",
                                              color: "rgba(4, 84, 2, 1)",
                                            }}
                                          >
                                            Touch me
                                          </span>
                                        </OverlayTrigger>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              ))
                          ) : (
                            <p className="text-center">No orders found.</p>
                          )}
                        </Col>
                      </div>
                    </Row>
                  </div>
                )} */}
                {state === "myOrders" && (
                  <div
                    className="card-body addressDiv"
                    style={{
                      padding: "20px",
                      backgroundColor: "#fff",
                      borderRadius: "12px",
                      boxShadow: "0 2px 6px rgba(0, 0, 0, 0.05)",
                    }}
                  >
                    <h4 className="mb-3">My Orders</h4>
                    <hr />
                    <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                      {orders.length > 0 ? (
                        orders.map((d, i) => {
                          const isReturned = d.returned === "1";
                          return (
                            <div
                              key={i}
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                border: "1px solid #e0e0e0",
                                backgroundColor: isReturned
                                  ? "#fff5e1"
                                  : "#fff",
                                borderRadius: "10px",
                                padding: "12px 16px",
                                marginBottom: "15px",
                                gap: "10px",
                                boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
                              }}
                            >
                              {/* Left section: image + name */}
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  flex: 1,
                                }}
                              >
                                <Link to={`/product/${d.product_id}`}>
                                  <img
                                    src={d.img1}
                                    alt=""
                                    style={{
                                      width: "65px",
                                      height: "55px",
                                      objectFit: "cover",
                                      borderRadius: "6px",
                                      marginRight: "12px",
                                    }}
                                  />
                                </Link>
                                <div style={{ flex: 1 }}>
                                  <Link
                                    to={`/product/${d.product_id}`}
                                    className="text-decoration-none text-dark"
                                  >
                                    <h6
                                      style={{
                                        fontSize: "14px",
                                        fontWeight: "600",
                                        margin: "0",
                                        textTransform: "uppercase",
                                      }}
                                    >
                                      {d.product_name}
                                    </h6>
                                    <p
                                      style={{
                                        fontSize: "12px",
                                        margin: "0",
                                        color: "#6c757d",
                                        textTransform: "uppercase",
                                      }}
                                    >
                                      {d.category}
                                    </p>
                                  </Link>
                                </div>
                              </div>

                              {/* Right section: status, qty, price, badge/button */}
                              <div
                                style={{
                                  textAlign: "right",
                                  minWidth: "120px",
                                }}
                              >
                                <p
                                  style={{
                                    margin: "0",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                >
                                  Status: {d.status}
                                </p>
                                <p
                                  style={{ margin: "2px 0", fontSize: "14px" }}
                                >
                                  Qty: {d.quantity} | ₹
                                  {d.offer_price * d.quantity}
                                </p>
                                {isReturned ? (
                                  <span
                                    style={{
                                      display: "inline-block",
                                      backgroundColor: "#ffc107",
                                      color: "#000",
                                      padding: "3px 10px",
                                      borderRadius: "6px",
                                      fontSize: "12px",
                                      marginTop: "4px",
                                      fontWeight: "500",
                                    }}
                                  >
                                    Returned
                                  </span>
                                ) : d.status === "confirm" ? (
                                  <button
                                    className="btn btn-outline-danger"
                                    style={{
                                      fontSize: "13px",
                                      padding: "4px 10px",
                                      marginTop: "4px",
                                    }}
                                    onClick={() => handleReturn(d.product_id)}
                                    disabled={
                                      returningProductId === d.product_id
                                    }
                                  >
                                    {returningProductId === d.product_id
                                      ? "Processing..."
                                      : "Return"}
                                  </button>
                                ) : (
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip id={`tooltip-${d.product_id}`}>
                                        If the product is damaged or has any
                                        issues after delivery, you can click the
                                        "Return" button.
                                      </Tooltip>
                                    }
                                  >
                                    <span
                                      style={{
                                        fontSize: "13px",
                                        cursor: "pointer",
                                        fontWeight: "500",
                                        color: "#ac081bff",
                                      }}
                                    >
                                     Warning
                                    </span>
                                  </OverlayTrigger>
                                )}
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <p className="text-center">No orders found.</p>
                      )}
                    </div>
                  </div>
                )}

                {state === "return" && (
                  <div className="card-body addressDiv">
                    <Row>
                      <div>
                        <h4 className="mb-3">Returned Products</h4>
                        <hr color="#e0e0e0" />
                        <Col
                          className="mb-3 shadow-none"
                          style={{ maxHeight: "400px", overflowY: "scroll" }}
                        >
                          {returnData.length > 0 ? (
                            returnData.map((d, i) => {
                              const { className, label } = getReturnBadge(
                                d.return_status
                              );
                              return (
                                <div
                                  key={i}
                                  className="card-body mb-2"
                                  style={{ border: "1px solid #e0e0e0" }}
                                >
                                  <div className="d-flex justify-content-between align-items-center">
                                    <div className="d-flex align-items-center">
                                      <img
                                        src={d.img1}
                                        alt="Returned"
                                        style={{
                                          width: "65px",
                                          height: "50px",
                                          objectFit: "cover",
                                          marginRight: "15px",
                                        }}
                                      />
                                      <div>
                                        <h6 className="text-uppercase">
                                          {d.product_name}
                                        </h6>
                                        <p className="mb-0 text-muted">
                                          {d.category}
                                        </p>
                                      </div>
                                    </div>
                                    <span className={`badge ${className}`}>
                                      {label}
                                    </span>
                                  </div>
                                </div>
                              );
                            })
                          ) : // Fallback: try to show any orders flagged returned if returnData empty
                          orders.filter((d) => d.returned === "1").length >
                            0 ? (
                            orders
                              .filter((d) => d.returned === "1")
                              .map((d, i) => {
                                const { className, label } = getReturnBadge(
                                  d.return_status || "Return Requested"
                                );
                                return (
                                  <div
                                    key={i}
                                    className="card-body mb-2"
                                    style={{ border: "1px solid #e0e0e0" }}
                                  >
                                    <div className="d-flex justify-content-between align-items-center">
                                      <div className="d-flex align-items-center">
                                        <img
                                          src={d.img1}
                                          alt="Returned"
                                          style={{
                                            width: "65px",
                                            height: "50px",
                                            objectFit: "cover",
                                            marginRight: "15px",
                                          }}
                                        />
                                        <div>
                                          <h6 className="text-uppercase">
                                            {d.product_name}
                                          </h6>
                                          <p className="mb-0 text-muted">
                                            {d.category}
                                          </p>
                                        </div>
                                      </div>
                                      <span className={`badge ${className}`}>
                                        {label}
                                      </span>
                                    </div>
                                  </div>
                                );
                              })
                          ) : (
                            <p className="text-center">
                              No return records found.
                            </p>
                          )}
                        </Col>
                      </div>
                    </Row>
                  </div>
                )}

                {state === "notifocation" && (
                  <div className="card-body addressDiv">
                    <Row>
                      <div>
                        <h4 className="mb-3">Notifications</h4>
                        <hr color="#e0e0e0" />
                        <NotificationMsg />
                      </div>
                    </Row>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </Container>
      <ToastContainer />
    </>
  );
}
